import { render, staticRenderFns } from "./ocrFace.vue?vue&type=template&id=51738324&scoped=true&"
import script from "./ocrFace.vue?vue&type=script&lang=js&"
export * from "./ocrFace.vue?vue&type=script&lang=js&"
import style0 from "./ocrFace.vue?vue&type=style&index=0&id=51738324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51738324",
  null
  
)

export default component.exports